import { render, staticRenderFns } from "./AddWheel.vue?vue&type=template&id=1417243a&"
import script from "./AddWheel.vue?vue&type=script&lang=js&"
export * from "./AddWheel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports